import defaultStates from '@/constants/lifecycle';

const pmnFunctionActions = {
  REFRESH_PMN_FUNCTIONS: 'REFRESH_PMN_FUNCTIONS',
  FETCH_PMN_FUNCTIONS: 'FETCH_PMN_FUNCTIONS',
  SHOW_PMN_FUNCTIONS: 'SHOW_PMN_FUNCTIONS',
  SHOW_PMN_FUNCTIONS_ERROR: 'SHOW_PMN_FUNCTIONS_ERROR',
  FETCH_PMN_FUNCTION: 'FETCH_PMN_FUNCTION',
  SHOW_PMN_FUNCTION: 'SHOW_PMN_FUNCTION',
  SHOW_PMN_FUNCTION_ERROR: 'SHOW_PMN_FUNCTION_ERROR',
  CLOSE_PMN_FUNCTIONS: 'CLOSE_PMN_FUNCTIONS',
  CLOSE_PMN_FUNCTION: 'CLOSE_PMN_FUNCTION',
};

export const pmnFunctionStates = {
  ...defaultStates,
};

export const pmnFunctionOperations = {
  DROP: 'drop',
  CLEAR: 'clear',
  PSEUDONYMISE: 'pseudonymise',
  GENERALISE: 'generalise',
};

export const pmnFunctionStore = [
  {
    code: 'clear',
    name: 'Clear',
    description: 'Values are transferred without any transformation',
  }, {
    code: 'drop',
    name: 'Drop',
    description: 'Values are dropped and not included in the transfer',
  }, {
    code: 'pseudonymise',
    name: 'Pseudonymise',
    description: 'Values are pseudonymised on transfer',
  }, {
    code: 'round_int',
    name: 'Round to nearest integer',
    description: 'Numeric values are rounded to the nearest integer',
  }, {
    code: 'reduce_precision_2dp',
    name: 'Reduce to 2 decimal places',
    description: 'Numeric values are reduced to 2 decimal places',
  }, {
    code: 'reduce_precision_2sf',
    name: 'Reduce to 2 significant figures',
    description: 'Numeric values are reduced to 2 significant figures',
  }, {
    code: 'exclude_outliers_18_65',
    name: 'Exclude values outside 18 - 65 inclusive',
    description: 'Numeric values below 18 or above 65 (inclusive) are excluded',
  }, {
    code: 'jitter_5p',
    name: 'Jitter',
    description: 'Numeric values have statistical noise added',
  }, {
    code: 'age_group_10s',
    name: 'Age to year band',
    description: 'Ages (as integers or dates) are generalised into bands of 10 years',
  }, {
    code: 'date_mid_period_year',
    name: 'Date to middle of year',
    description: 'Dates are generalised to the middle of the year',
  }, {
    code: 'date_mid_period_quarter',
    name: 'Date to middle of quarter',
    description: 'Dates are generalised to the middle of the quarter',
  }, {
    code: 'date_mid_period_month',
    name: 'Date to middle of month',
    description: 'Dates are generalised to the middle of the month',
  }, {
    code: 'date_part_year',
    name: 'Extract year from date',
    description: 'Dates are generalised to the year',
  }, {
    code: 'date_part_year_month',
    name: 'Extract year and month from date',
    description: 'Dates are generalised to the month and year',
  }, {
    code: 'date_part_year_day_of_week',
    name: 'Extract day of week from date',
    description: 'Dates are generalised to the day of the week',
  }, {
    code: 'split_first_word',
    name: 'Take first word',
    description: 'The first word or text is extracted for transfer',
  }, {
    code: 'split_second_word',
    name: 'Take second word',
    description: 'The second word or text is extracted for transfer',
  }, {
    code: 'mask_ip_address',
    name: 'Mask IP Address',
    description: 'IP addresses are masked',
  },
];

export default pmnFunctionActions;
